import { render, staticRenderFns } from "./UpgradeStrategy.vue?vue&type=template&id=a083f7b0&scoped=true&"
import script from "./UpgradeStrategy.vue?vue&type=script&lang=js&"
export * from "./UpgradeStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a083f7b0",
  null
  
)

export default component.exports